import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default class AlertDialog extends React.Component {
	render(){
        const { proButton } = this.props
        const contentStyle = (this.props.pre) ? {whiteSpace:"pre-line"} : {}

		return (
			<Dialog
                classes={{ paper: "alertPaper" }}   
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={contentStyle}>{this.props.content}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    {(proButton)&&<Button onClick={this.props.showPaymentDialog} color="secondary" variant="contained" aria-label="JobSwipe Pro">
                        JobSwipe Pro
                    </Button>}
                    <Button onClick={this.props.onClose} color="primary" aria-label="Ok" autoFocus={!proButton}>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
		)
	}
}